import { createContext } from "react";

const DF_OT0012Context = createContext();

export { DF_OT0012Context };
